function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import AllhomesArticleCard, { articleCardPropTypes } from './allhomes-article-card';
import styleBuilder from './allhomes-article-wrapper.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
const defaultProps = {
  imagePosition: 'left',
  fixedHeight: true,
  maxLines: 3
};
const twoRowMaxLines = 2;
const AllhomesArticleWrapper = _ref => {
  let allArticles = _ref.articles,
    layout = _ref.layout,
    appearance = _ref.appearance;
  const styles = styleBuilder({
    layout
  });
  const articles = allArticles.slice(0, 3);
  if (layout !== 'two-row') {
    return ___EmotionJSX("div", {
      css: styles.articleWrapper
    }, articles.map(article => ___EmotionJSX(AllhomesArticleCard, _extends({
      css: styles.card,
      key: article.url,
      appearance: appearance
    }, defaultProps, article))));
  }
  const remainder = articles.length % 2;
  return ___EmotionJSX("div", {
    css: styles.articleWrapper
  }, remainder > 0 && ___EmotionJSX(AllhomesArticleCard, _extends({
    css: styles.firstCard,
    appearance: appearance
  }, defaultProps, {
    maxLines: twoRowMaxLines
  }, articles[0])), articles.length > 1 && ___EmotionJSX("div", {
    css: styles.secondRow
  }, articles.slice(remainder).map(article => ___EmotionJSX(AllhomesArticleCard, _extends({
    key: article.url,
    css: styles.card,
    appearance: appearance
  }, defaultProps, {
    maxLines: twoRowMaxLines
  }, article)))));
};
AllhomesArticleWrapper.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape(articleCardPropTypes)),
  layout: PropTypes.oneOf(['column', 'row', 'two-row']),
  appearance: PropTypes.oneOf(['research', 'default'])
};
AllhomesArticleWrapper.defaultProps = {
  articles: [],
  layout: 'column',
  appearance: 'default'
};
export default AllhomesArticleWrapper;